import { createSelector } from '@reduxjs/toolkit';
import { filter } from '€lib/fp';
import { RootState } from '€slices/types';
import STAGE_GROUPS from '€lib/stages/stageGroups';
import { STAGE_LOST, STAGE_CLOSEOUT } from '€lib/stages/stageNames';
import { BrokerApplication } from '€lib/types/Application';

export const allApplications = (state: RootState) => state.applications.items;

export const notInsuranceApplications = createSelector(
    allApplications,
    filter<BrokerApplication>(app => app.applicationTypeNameInternal !== 'Insurance'),
);

export const completedApplications = createSelector(
    notInsuranceApplications,
    filter<BrokerApplication>(app =>
        [STAGE_CLOSEOUT].includes(STAGE_GROUPS[app.salesPipelineStage]),
    ),
);

export const liveApplications = createSelector(
    notInsuranceApplications,
    filter<BrokerApplication>(app => STAGE_GROUPS[app.salesPipelineStage] < STAGE_CLOSEOUT),
);

export const cancelledApplications = createSelector(
    notInsuranceApplications,
    filter<BrokerApplication>(app => STAGE_GROUPS[app.salesPipelineStage] === STAGE_LOST),
);
